import React from 'react';
import { View, Text } from 'react-native'
import styled from 'styled-components/native';

import { mentionHighlight } from 'app/src/styles/colors';

const MENTION_REGEX_SPLIT = /(@\[[^\]]*\]\{[\w-\d]+\})/g;
const MENTION_REGEX = /@\[([^\]]*)\]\{[\w-\d]+\}/g;

const Container = styled(View)`
  flex-direction: row;
`;

const Mention = styled(Text)`
  background-color: ${mentionHighlight};
`;

export const highlightMentions = (text) => {
  const array = text.split(MENTION_REGEX_SPLIT);

  return array.map((item, index) => {
    if (item.match(MENTION_REGEX)) {
      return (
        <Mention key={index}>
         {item.replace(MENTION_REGEX, '$1')}
        </Mention>
      );
    } else {
      return <Text key={index}>{item}</Text>;
    }
  });
};

const Body = ({ content }) => (
  <Container>
    {highlightMentions(content)}
  </Container>
);

export default Body;
